const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

const setHeadingId = (heading, fallbackIndex, usedIds) => {
  const text = heading.textContent.trim();
  const baseId = heading.id || slugify(text) || `section-${fallbackIndex + 1}`;
  let finalId = baseId;
  let index = 2;

  while (usedIds.has(finalId) && heading.id !== finalId) {
    finalId = `${baseId}-${index}`;
    index += 1;
  }

  heading.id = finalId;
  usedIds.add(finalId);

  return finalId;
};

const createTocLink = (heading, className, index, usedIds) => {
  const link = document.createElement('a');
  link.className = className;
  link.href = `#${setHeadingId(heading, index, usedIds)}`;
  link.textContent = heading.textContent.trim();

  return link;
};

const scrollToHeading = (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const targetId = decodeURIComponent(link.getAttribute('href').slice(1));
  const target = document.getElementById(targetId);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.pushState(null, '', link.href);
};

const buildArticleToc = (scope = document) => {
  scope.querySelectorAll('[data-article-content]').forEach((content) => {
    if (content.dataset.articleTocReady === 'true') return;

    const toc = content.querySelector('[data-article-toc]');
    const list = content.querySelector('[data-article-toc-list]');

    if (!toc || !list) return;

    list.querySelectorAll('[data-generated-toc-item]').forEach((item) => item.remove());

    toc.hidden = true;

    const headings = [...content.querySelectorAll('h2, h3')].filter(
      (heading) => heading.textContent.trim() !== '' && !heading.closest('[data-article-toc]')
    );

    const groups = [];
    let currentGroup = null;

    headings.forEach((heading) => {
      if (heading.tagName === 'H2') {
        currentGroup = {
          heading,
          children: [],
        };
        groups.push(currentGroup);
      } else if (heading.tagName === 'H3' && currentGroup) {
        currentGroup.children.push(heading);
      }
    });

    if (!groups.length) return;

    const usedIds = new Set(
      [...document.querySelectorAll('[id]')]
        .map((node) => node.id)
        .filter(Boolean)
    );

    groups.forEach((group, groupIndex) => {
      const item = document.createElement('li');
      item.className = 'article-toc__item article-toc__item--h2';
      item.dataset.generatedTocItem = 'true';

      if (group.children.length) {
        item.classList.add('article-toc__item--has-children');

        const row = document.createElement('div');
        row.className = 'article-toc__row';
        row.appendChild(createTocLink(group.heading, 'article-toc__link article-toc__link--h2', groupIndex, usedIds));

        const sublistId = `article-toc-sublist-${groupIndex + 1}`;
        const toggle = document.createElement('button');
        toggle.className = 'article-toc__toggle';
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', sublistId);
        toggle.setAttribute('aria-label', 'Show subsections');
        toggle.innerHTML = '<span class="article-toc__toggle-icon" aria-hidden="true">&#9662;</span>';

        const sublist = document.createElement('ol');
        sublist.className = 'article-toc__sublist';
        sublist.id = sublistId;
        sublist.hidden = true;

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          toggle.setAttribute('aria-label', isOpen ? 'Show subsections' : 'Hide subsections');
          sublist.hidden = isOpen;
        });

        row.appendChild(toggle);
        item.appendChild(row);

        group.children.forEach((child, childIndex) => {
          const childItem = document.createElement('li');
          childItem.className = 'article-toc__subitem article-toc__item--h3';
          childItem.dataset.generatedTocItem = 'true';
          childItem.appendChild(
            createTocLink(child, 'article-toc__link article-toc__link--h3', `${groupIndex}-${childIndex}`, usedIds)
          );
          sublist.appendChild(childItem);
        });

        item.appendChild(sublist);
      } else {
        item.appendChild(createTocLink(group.heading, 'article-toc__link article-toc__link--h2', groupIndex, usedIds));
      }

      list.appendChild(item);
    });

    groups[0].heading.insertAdjacentElement('beforebegin', toc);
    toc.hidden = false;
    toc.addEventListener('click', scrollToHeading);
    content.dataset.articleTocReady = 'true';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => buildArticleToc());
} else {
  buildArticleToc();
}

document.addEventListener('shopify:section:load', (event) => {
  buildArticleToc(event.target);
});